import { isBefore, isAfter, parse, endOfDay } from "date-fns";

type Input = {
  now: Date;
  startDate?: string;
  expirationDate?: string;
};

export const computePeriodStatus = (input: Input) => {
  const { now, startDate, expirationDate } = input;

  const startDateParsed = startDate
    ? parse(startDate, "yyyy/MM/dd", new Date())
    : null;
  const expirationDateParsed = expirationDate
    ? endOfDay(parse(expirationDate, "yyyy/MM/dd", new Date()))
    : null;

  const isBeforeRange = startDateParsed
    ? isBefore(now, startDateParsed)
    : false;
  const isAfterRange = expirationDateParsed
    ? isAfter(now, expirationDateParsed)
    : false;

  const isPeriodExpired = isBeforeRange || isAfterRange;

  return { isBeforeRange, isAfterRange, isPeriodExpired };
};
